import React from "react";

const SmokeTreatment = () => {
  return (
    <div className="bg-gray-10 p-2 flex flex-col max-w-[464px] ">
      <p className="text-teal-300 text-left text-body-sm  font-normal">
        Use the current Smoking Cessation Program as organized with your Pharmacy. If
        the patient agrees to participate, a reminder to book an appointment will be
        available at the end of this service in the EDUCATION section
      </p>
    </div>
  );
};

export default SmokeTreatment;
